import { splitUpIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Split = createIcon({
  displayName: 'Split',
  paths: [
    'M511.957 853.291c-22.067-0.021-40.226-16.751-42.415-38.251l-0.209-4.373v-280.998l-213.333-213.335v25c0 23.564-19.103 42.625-42.667 42.625-22.088 0-40.268-16.74-42.458-38.25l-0.208-4.375v-128c0-23.564 19.103-42.667 42.667-42.667h128l4.375 0.208c21.51 2.19 38.292 20.371 38.292 42.458 0 23.564-19.103 42.667-42.667 42.667h-25l225.832 225.835 2.833 3.123c6.225 7.595 9.668 17.139 9.668 27.042v298.667c0 23.565-19.145 42.624-42.709 42.624z',
    'M810.667 170.667c23.565 0 42.667 19.103 42.667 42.667v128c0 23.564-19.102 42.667-42.667 42.667s-42.667-19.103-42.667-42.667v-25l-173.585 173.54c-3.127-11.648-8.708-22.549-16.414-31.957l-1.378-1.626-2.833-3.123-1.455-1.502-30.17-30.207 165.5-165.458h-24.998c-23.565 0-42.667-19.103-42.667-42.667s19.102-42.667 42.667-42.667h128z'
  ],
  canvasPaths: canvasIconPaths(splitUpIcon)
})
